<template>
  <drawer :value="true" :width="width" @close="$emit('exit')">
    <v-container class="px-5 px-md-16 py-8">
      <v-card-title
        class="display-1 font-weight-bold pa-0 mb-8 letter-spacing-normal"
      >
        {{ project.name }}
      </v-card-title>
      <v-list-item-group color="primary" class="mb-12">
        <v-list-item
          class="d-flex justify-space-between align-center no-pointer-events px-0"
          :ripple="false"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              Community Manager
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>
              {{ project.manager.full_name.capitalize() }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="d-flex justify-space-between align-center px-0"
          :ripple="false"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              Location
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>
              <a @click="seeProjectMap">See Map</a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>

      <v-row>
        <v-col sm="12">
          <v-row class="justify-lg-space-between align-center">
            <v-card-title
              class="py-0 title font-weight-bold letter-spacing-normal"
            >
              Transaction History
            </v-card-title>
          </v-row>
          <v-row class="justify-lg-space-between align-center">
            <v-col class="pa-0">
              <v-data-table
                :options.sync="pagination"
                class="distinct-table border-radius-0 v-data-table-1 v-data-table-1--style3 details-table"
                :headers="headers"
                :items="transactions"
                v-bind="
                  totalTransactions < pagination.itemsPerPage
                    ? { hideDefaultFooter: true }
                    : { serverItemsLength: totalTransactions }
                "
              >
                <template v-slot:item.created_at="{ value }">
                  {{ value ? $moment(value).format('MMMM DD YYYY') : '' }}
                </template>
                <template v-slot:item.amount="{ value }">
                  ${{ value.currency(2) }}
                </template>

                <template v-slot:body.append>
                  <tr class="table-footer">
                    <td>Total</td>
                    <td>${{ totalAmount.currency(2) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <template v-slot:append>
      <div
        class="flex-column flex-md-row px-5 px-md-16 py-12 d-flex justify-lg-space-between"
      >
        <v-btn
          v-if="!project.graduated"
          large
          color="yellow"
          class="px-14 mb-2 mb-md-0"
          min-width="45%"
          @click.stop="$emit('newPayout')"
        >
          New Payout
        </v-btn>
        <v-btn
          min-width="45%"
          v-bind="project.graduated ? { block: true } : {}"
          large
          class="primary px-5 px-md-14"
          @click.stop="$emit('exit')"
        >
          Done
        </v-btn>
      </div>
    </template>
  </drawer>
</template>

<script>
import Drawer from '@layouts/_partials/Drawer';
import Transaction from '@models/Transaction';

export default {
  name: 'ProjectReport',
  components: { Drawer },
  props: {
    project: {
      type: Object,
      required: true,
    },
    width: {
      type: [String, Number],
      default: 350,
    },
  },
  data() {
    return {
      totalAmount: 0,
      totalTransactions: 0,
      headers: [
        { text: 'Date', value: 'created_at' },
        { text: 'Amount', value: 'amount' },
      ],
      pagination: {
        sortBy: ['created_at'],
        itemsPerPage: 10,
        page: 1,
        sortDesc: [true],
      },
      transactionModel: new Transaction({
        ...this.pagination,
        filters: {
          project_id: this.project.id,
          type: 'debit',
        },
      }),
      transactions: [],
    };
  },
  watch: {
    pagination: {
      handler() {
        this.fetchTransactions();
      },
      deep: true,
    },
  },
  methods: {
    seeProjectMap() {
      this.$emit('seeProjectMap', this.project);
    },
    async fetchTransactions() {
      this.syncPagination();
      let response = await this.transactionModel.get();
      if (response) {
        this.transactions = response.data;
        this.totalAmount = response.meta.total_amount;
        this.totalTransactions = response.pagination.total;
      }
    },
    syncPagination() {
      Object.assign(this.transactionModel, this.pagination);
    },
  },
  mounted() {
    this.fetchTransactions();
  },
};
</script>

<style lang="scss" scoped></style>
